import React from "react";

export const phoneHelper = {
    phoneLink,
};

function phoneLink(value) {
    let phone = (value.match(/\d/g) || []).join('');
    if(phone.length === 11) {
        if(phone[0] == 8 || phone[0] == 7) {
            phone = phone.slice(1);
            phone = `+7${phone}`;
        }
    } else if(phone.length === 10) {
        phone = `+7${phone}`;
    }

    let formattedPhone = /^\+7\d{10}$/.test(phone)
        ? phone.replace(/^\+7(\d{3})(\d{3})(\d{2})(\d{2})$/, '+7 ($1) $2 $3 $4')
        : phone;

    return (<a className="link" href={`tel:${phone}`}>
        <b>{formattedPhone}</b>
    </a>);
}

